(function () {
    'use strict';

    Directives.DatesForReportDirective = function DatesForReportDirective() {

        // @ngInject
        function DatesForReportDirectiveControllerFunc(moment, $translate, $scope, $timeout, $injector, UiPersistenceService) {

            this.constructor.$super.call(this, $scope, $injector);
            this.__objectType = 'DatesForReportDirectiveController';

            this.UiPersistenceService = UiPersistenceService;
            this.moment = moment;
            this.$translate = $translate;

            this.hbReportModel = this.UiPersistenceService.getUiPersistence(this.hbReportName);
            this.hbReportModel = this.hbReportModel || {};
            this.hbReportModel.startDate = this.hbReportModel.startDate ? this.moment(this.hbReportModel.startDate).format('MMM DD, YYYY') : this.moment().subtract(1, 'year').format('MMM DD, YYYY');
            this.hbReportModel.endDate = this.moment(this.hbReportModel.endDate).format('MMM DD, YYYY');
            this.dateErrorMessage = null;

            $timeout(function () {
                this.hbReportFunction();
            }.bind(this), 120);
        }

        var DatesForReportDirectiveController = Class(Controllers.BaseController, {
            constructor: DatesForReportDirectiveControllerFunc,

            startDateChanged: function (newDate) {
                this.hbReportModel.startDate = newDate;
                this.dateChanged();
            },

            endDateChanged: function (newDate) {
                this.hbReportModel.endDate = newDate;
                this.dateChanged();
            },

            dateChanged: function dateChanged() {
                if (!this.isValidDates()) {
                    this.dateErrorMessage = this.$translate.instant(
                        'REPORTS.ANALYTICS.SUMMARY._DATE_FILTER_ERROR_MESSAGE_');
                } else {
                    this.dateErrorMessage = null;

                    this.UiPersistenceService.setUiPersistence(
                        this.hbReportName, this.hbReportModel);

                    this.hbReportFunction();
                }
            },

            isValidDates: function isValidLeadsDates() {
                // End date should not be earlier than start date
                // 3rd party DatePicker plugin accepts and returns a string,
                // therefore we need to convert back into a date in order to compare...
                var start = new Date(this.hbReportModel.startDate);
                var end = new Date(this.hbReportModel.endDate);
                return start <= end;
            }
        });

        return {
            scope: {
                hbReportName: '@',
                hbReportModel: '=',
                hbReportFunction: '&',
            },
            templateUrl: 'angular/app/modules/core/features/reports/analytics/dates_for_report_template.html',
            controller: DatesForReportDirectiveController,
            controllerAs: 'datesForReportVm',
            bindToController: true
        };
    };
}());



